import React, { useId } from 'react';
import DotWavesS from './DotWavesS';

/**
 * Sistema de fondo arcade neón oscuro.
 * Capa principal: negro/violeta con glow cyan/magenta y un grid sutil.
 */
function BackgroundStack({ className = '', children, sidebarExpanded = false, scrollable = false }) {
    const uid = useId();
    const noiseId = `simNoise${uid.replace(/:/g, '')}`;

    return (
        <div
            className={['relative min-h-0 min-w-0', scrollable ? 'overflow-y-auto' : 'overflow-hidden', className].filter(Boolean).join(' ')}
            style={{ backgroundColor: '#05050a' }}
        >
            {/* Capa 01 — Grano fractal sutil */}
            <svg
                className="pointer-events-none absolute inset-0 z-0 h-full w-full"
                style={{ opacity: 0.06 }}
                aria-hidden
            >
                <defs>
                    <filter id={noiseId} x="0" y="0" width="100%" height="100%" filterUnits="objectBoundingBox">
                        <feTurbulence type="fractalNoise" baseFrequency="0.8" numOctaves="4" seed="2" result="n" />
                        <feColorMatrix in="n" type="saturate" values="0" result="g" />
                    </filter>
                </defs>
                <rect width="100%" height="100%" filter={`url(#${noiseId})`} fill="#ffffff" />
            </svg>

            {/* Capa 02 — Glows radiales cyan/magenta + grid cyberpunk */}
            <div
                className="pointer-events-none absolute inset-0 z-0"
                style={{
                    backgroundImage: `
                        radial-gradient(ellipse 80% 60% at 0% 0%, rgba(34, 211, 238, 0.10) 0%, transparent 55%),
                        radial-gradient(ellipse 75% 65% at 100% 100%, rgba(232, 121, 249, 0.10) 0%, transparent 55%),
                        radial-gradient(ellipse 60% 50% at 50% 50%, rgba(167, 139, 250, 0.05) 0%, transparent 70%),
                        linear-gradient(rgba(34, 211, 238, 0.04) 1px, transparent 1px),
                        linear-gradient(90deg, rgba(34, 211, 238, 0.04) 1px, transparent 1px),
                        linear-gradient(165deg, #07071a 0%, #0a0a14 48%, #100b1f 100%)
                    `,
                    backgroundSize: '100% 100%, 100% 100%, 100% 100%, 36px 36px, 36px 36px, 100% 100%',
                }}
            />

            {/* Capa 03 — Ondas de puntos */}
            <DotWavesS sidebarExpanded={sidebarExpanded} />

            <div className="relative z-10 box-border flex h-full min-h-0 w-full min-w-0 flex-1 flex-col">
                {children}
            </div>
        </div>
    );
}

export default BackgroundStack;
